// See https://docs.google.com/spreadsheets/d/1k2yNJIL4onQay7KGxd_QWLDyBmJP5VQZSwIFrB9eBv4 for more details
// on nav tracking fields.
export function getCategory(element) {
    return getClosestDataAttribute(element, 'data-category');
}
export function getSubcategory(element) {
    return getClosestDataAttribute(element, 'data-subcategory');
}
export function getLocation(element) {
    return getClosestDataAttribute(element, 'data-component-type');
}
export function getNavDeviceType(element) {
    return getClosestDataAttribute(element, 'data-nav-device-type');
}
export function isNavSticky(element) {
    return element?.closest('.isSticky') ? true : false;
}
function getClosestDataAttribute(element, dataAttribute) {
    if (!element) {
        return undefined;
    }
    return element.closest(`[${dataAttribute}]`)?.getAttribute(dataAttribute) || undefined;
}
